import { ready } from '~/core'

ready('navSecondary', '.navSecondary', (navSecondary) => {
  let sectionLinks = document.querySelectorAll('.navSecondary-link')
  let sections = [...document.querySelectorAll('.pageCols-content section')]
  let windowHeight = window.innerHeight
  let scrollPoint = windowHeight / 4
  window.addEventListener('scroll', (event) => {
    sectionLinks.forEach((link) => {
      let linkParent = link.closest('.navSecondary-item')
      let section = document.querySelector(link.hash)
      let sectionHeight = section.offsetHeight
      let sectionSize = section.getBoundingClientRect()
      let sectionTop = sectionSize.top
      let sectionBottom = sectionSize.bottom
      if (sectionTop <= scrollPoint && sectionBottom >= scrollPoint) {
        linkParent.classList.add('is-current')
        //- section.classList.add('is-scrolled')
      } else {
        linkParent.classList.remove('is-current')
        //- section.classList.remove('is-scrolled')
      }
    })
  })
})
